export const SET_CONTENT_DISCOVERY_LIST_SIZE = 'SET_CONTENT_DISCOVERY_LIST_SIZE'
export const setContentDiscoveryListSize = (payload) => ({
  type: SET_CONTENT_DISCOVERY_LIST_SIZE,
  payload,
})
